import React from "react";
import { Button } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiSquareEditOutline } from "@mdi/js";
import CardShell from "./CardShell";

const InspectionResultCard = ({ job }) => {
  const count = job.inspection?.item_count || 0;
  const reportId = job.report_id;

  return (
    <CardShell
      icon={
        <Icon path={mdiSquareEditOutline} size={0.7} className="jd-card-icon" />
      }
      title="Inspection Result"
      className="jd-card--half jd-inspection-card"
    >
      <div className="jd-inspection-row">
        <div>
          <div className="jd-inspection-count">{count}</div>
          <div className="jd-subtle">{count === 1 ? "Item" : "Items"} recorded</div>
        </div>
        {reportId && (
          <Button
            variant="outline-primary"
            size="sm"
            onClick={() =>
              window.open(
                `/reports/${reportId}/edit`,
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            Edit
          </Button>
        )}
      </div>
    </CardShell>
  );
};

export default InspectionResultCard;
